import React, { useState } from 'react';
import LightBox from '../LightBox';
import styled from 'styled-components';

const SImg = styled.img`
  margin: 4px;
  cursor: pointer;
  width: 50px;
  transition: 0.3s ease-in-out;
`;

const Screenshot: React.FC<{ allScreens: { screen: string; id: string }[] }> = (props) => {
  const [lightBoxIsOpen, openLightBox] = useState(false);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const currentScreen = props.allScreens.length ? props.allScreens[currentMediaIndex].screen : '';
  const currenttext = props.allScreens.length ? props.allScreens[currentMediaIndex].id : '';
  const lastIndex = props.allScreens.length - 1;
  const isLast = currentMediaIndex === lastIndex;
  const isFirst = currentMediaIndex === 0;

  return (
    <>
      {lightBoxIsOpen && (
        <LightBox
          mainSrc={currentScreen}
          text={currenttext}
          onCloseRequest={() => openLightBox(false)}
          onClickOutSide={() => openLightBox(false)}
          next={() => setCurrentMediaIndex(isLast ? 0 : currentMediaIndex + 1)}
          prev={() => setCurrentMediaIndex(isFirst ? lastIndex : currentMediaIndex - 1)}
        />
      )}
      <SImg src={currentScreen} onClick={() => openLightBox(true)} />
    </>
  );
};

export default Screenshot;
